<script lang="ts">
    import { Col, Image } from "sveltestrap";
    import {personalData,personalContact} from "../../../store"
    import { href } from "../../../utils/Constant/Constant";
    import Link from "svelte-link";
    let imgPath:string = "/assets/images/user"
    let setPersonalData:any
    personalData.subscribe((value)=>{
        setPersonalData = value
    })
    const handleAddUser = (id:number) => {
        personalContact.update(value => value = id)
    }
    let setPersonalContact:number
    personalContact.subscribe((value)=>{
        setPersonalContact = value
    })
</script>
<Col xl="4" md="5" class="xl-50">
    <div class="nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
        {#if setPersonalData.length > 0}
            {#each setPersonalData as userItem,index}
                <Link class="contact-tab-0 nav-link {setPersonalContact == index ? "active" : ""}" id="v-pills-user" href={href} on:click={()=>handleAddUser(index)}>
                    <div class="media">
                        <Image fluid class="img-50 m-r-20 rounded-circle update_img_0" src="{imgPath}/2.png" alt="" />
                        <div class="media-body">
                            <h6> 
                                <span class="first_name_0">{userItem.fname} </span>
                                <span class="last_name_0">{userItem.lname}</span>
                            </h6>
                            <p class="email_add_0">{userItem.email}</p>
                        </div>
                    </div>
                </Link>
            {/each}
        {:else}
            <p>{'You need to create new contact.'}</p>
        {/if}
    </div>
</Col>